export enum HrVenturePointsModalMode {
  CREATE = "create",
  VIEW = "view",
  EDIT = "edit",
}
